<template>
  <div ref="container" class="container-timeline" @click.stop="setScale">
    <div
      @click="infoIsOn = !infoIsOn"
      class="info"
      v-if="infoIsOn"
      ref="infoWindow"
      :style="getLeftInfoWindow()"
      v-click-outside="closeInfo"
    >
      <div>{{ driverState[info.v] }}</div>
      <div>{{ minToString(info.min) }}</div>
      <div>{{ date2time(info.from) }}</div>
      <div>{{ date2time(info.to) }}</div>
    </div>
    <div
      :style="getStyle(item)"
      v-for="item in data"
      :key="item.id"
      @click.stop="showInfo($event, item)"
    ></div>
    <div v-for="hour in hours" :key="hour.key" :style="getHoursStyle(hour)">
      {{ hour.label }}
    </div>
  </div>
</template>
<script>
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'TimeLine',
  mixins: [UtilityMixin],
  props: {
    options: {
      default: null,
      type: Object,
    },
    data: {
      default: null,
      type: Array,
    },
  },
  data() {
    return {
      status: ['FERMO', 'IN MOVIMENTO'],
      card: ['NON PRESENTE', 'PRESENTE'],
      driverState: [
        'RIPOSO',
        'DISPONIBILE',
        'LAVORO',
        'GUIDA',
        '-',
        '-',
        'ERRORE',
        'N.D.',
      ],
      colors: [
        'green',
        'yellow',
        'blue',
        'red',
        'black',
        'black',
        'black',
        'brown',
      ],
      start: null,
      end: null,
      containerWidth: null,
      unitMinPx: 0,
      hours: [],
      infoIsOn: false,
      offsetLeft: 0,
      eventLeft: 0,
      info: null,
      is24h: true,
    }
  },
  mounted() {
    const vm = this
    vm.calcBase()
    window.addEventListener('resize', vm.calcBase)
  },

  watch: {
    data(newData, oldData) {
      this.calcBase()
    },
  },
  methods: {
    closeInfo() {
      const vm = this
      vm.infoIsOn = false
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.calcBase)
    },
    setScale() {
      const vm = this
      vm.is24h = !vm.is24h
      vm.calcBase()
    },
    calcBase() {
      const vm = this
      vm.containerWidth = vm.$refs['container'].offsetWidth - 20
      vm.offsetLeft = vm.$refs['container'].offsetLeft
      if (vm.data && vm.data.length > 0) {
        vm.start = vm.newDate(vm.data[0].from)
        vm.end = vm.newDate(vm.data[vm.data.length - 1].to)
        if (vm.is24h) {
          vm.zeroDate(vm.start)
          vm.endDate(vm.end)
        }

        let minutes = vm.diffDateMin(vm.end, vm.start)
        vm.unitMinPx = vm.containerWidth / minutes

        let hstart = vm.start.getHours() + 1
        let hend = vm.end.getHours()
        vm.hours = []
        let d = vm.newDate(vm.start)
        for (let i = hstart; i <= hend; i++) {
          let hh = {}

          hh.label = ('0' + i).slice(-2)

          hh.key = 'hh' + i
          d.setHours(i)
          d.setMinutes(0)
          d.setSeconds(0)
          hh.min = vm.diffDateMin(d, vm.start)
          vm.hours.push(hh)
        }
      }
    },
    showInfo(event, item) {
      const vm = this
      vm.infoIsOn = true
      vm.info = item
      vm.eventLeft = event.target.offsetLeft
    },
    getLeftInfoWindow() {
      const vm = this
      if (vm.infoIsOn) {
        return 'left: ' + vm.eventLeft + 'px;'
      }
      return ''
    },
    calcOffset(item) {
      const vm = this
      let offset = vm.diffDateMin(item.from, vm.start)
      return Math.trunc(10 + vm.unitMinPx * offset)
    },
    getTitle(item) {
      const vm = this
      return vm.driverState[item.c]
    },
    calcWidth(item) {
      const vm = this
      return Math.trunc(item.min * vm.unitMinPx)
    },
    getHoursStyle(hour) {
      const vm = this
      let s =
        'margin.left: -5px; position:absolute; height:20px; left:' +
        Math.trunc(10 + hour.min * vm.unitMinPx) +
        'px; top:20px;font-size: 9px; width:15px'
      return s
    },
    getStyle(item) {
      const vm = this
      if (!vm.containerWidth) return

      let w = vm.calcWidth(item)
      let p = vm.calcOffset(item)
      let s =
        ' position:absolute; height:' +
        vm.options.height +
        'px; left:' +
        p +
        'px; top:4px; width:' +
        w +
        'px; background-color:' +
        vm.colors[item.v] +
        ';'
      if (vm.infoIsOn && vm.info.from === item.from) {
        s = s + 'border: 3px solid black;'
      }
      return s
    },
  },
}
</script>
<style scoped>
.sw {
  position: absolute;
  top: 30px;
  right: 0px;
  background-color: white;
  border-style: solid;
  border-width: 1px;
  font-size: 9px;
  width: 50px;
  padding: 2px;
}

.info {
  position: relative;
  left: 0px;
  top: -62px;
  font-size: 10px;
  border-color: gray;
  border-style: solid;
  border-width: 1px;
  background-color: white;
  line-height: 12px;
  font-weight: bold;
  height: auto;
  width: 100px;
  padding: 5px 10px 10px 10px;
  z-index: 1000;
}

.base {
  background-color: red;
  width: 100%;
}
.container-timeline {
  position: relative;
  width: 100%;
  height: 34px;
  background-color: lightgray;
  opacity: 1;
}

.hours {
  position: absolute;
  top: 20px;
  height: 20px;
  font-size: 6px;
}
</style>
